import React from 'react';

function EcommerceConversionSolutions() {
  const handleGetStartedClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('ecommerce-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="ecommerce-conversion-section">
      <div className="container">
        {/* Centered Section Header */}
        <div className="ecommerce-conversion-header">
          <div className="ecommerce-conversion-badge-row">
            <span className="ecommerce-conversion-badge">Conversion-Driven Architecture</span>
            <div className="ecommerce-conversion-badge-line"></div>
          </div>

          <h2 className="ecommerce-conversion-title">
            E-commerce Website Development Company That <span className="text-red">Increases Your Conversions</span>
          </h2>
        </div>

        {/* 2-Column Grid for Content and Graphic */}
        <div className="ecommerce-conversion-container">
          {/* Left Column: Content */}
          <div className="ecommerce-conversion-left">
            <p className="ecommerce-conversion-desc">
              Want to change your online store into a successful conversion platform? Our e-commerce website development company in Pakistan creates high-performing websites that attract visitors and turn them into buyers. Your e-commerce platform needs to be attractive to customers and guide them from product discovery to checkout completion. Our expert development team understands the psychology of online shopping and builds websites that eliminate friction points and ensure a seamless order processing experience. Our developers provide user-friendly navigation systems and a fast loading time in the e-commerce store to make purchases easy for the customers. We also focus on mobile-responsive designs and intuitive checkout processes to make sure the website visitors do not leave without buying. Our conversion-optimized websites have the best product placement and call-to-action buttons that work together to increase your sales performance.
            </p>

            <p className="ecommerce-conversion-desc">
              Our eCommerce store development services use advanced analytics, tracking, and A/B testing to improve your conversion rates. We have performance monitoring tools that help you understand customer behavior for the best outcomes. We manage everything for you, be it inventory management systems or quality shopping experiences, and provide you with a solution that can adapt to changing market demands. Ready to turn your website visitors into loyal customers? Get a free quote now for a free consultation and find out how our e-commerce development processes can double your online conversions.
            </p>

            {/* Key Value Feature Pills */}
            <div className="ecommerce-features-chips">
              <div className="ecom-chip">
                <span className="ecom-chip-dot"></span>
                <span>Frictionless Checkout</span>
              </div>
              <div className="ecom-chip">
                <span className="ecom-chip-dot"></span>
                <span>Lightning Fast Speed</span>
              </div>
              <div className="ecom-chip">
                <span className="ecom-chip-dot"></span>
                <span>100% Mobile Responsive</span>
              </div>
              <div className="ecom-chip">
                <span className="ecom-chip-dot"></span>
                <span>A/B Conversion Testing</span>
              </div>
            </div>

            <button className="btn-ecommerce-get-started" onClick={handleGetStartedClick}>
              Get started
            </button>
          </div>

          {/* Right Column: High-Impact 3D E-Commerce Platform Graphic */}
          <div className="ecommerce-conversion-right">
            <div className="ecommerce-conversion-img-wrapper">
              <img 
                src="/assets/images/ecommerce_conversions_showcase.jpg" 
                alt="E-Commerce Conversion Website Platform" 
                className="ecommerce-conversion-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EcommerceConversionSolutions;
